import "@/App.css";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Looks from "./components/Looks";
import Prints from "./components/Prints";
import About from "./components/About";
import Care from "./components/Care";
import Contact from "./components/Contact";
import { FloatingWhatsApp } from "./components/WhatsApp";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <Nav />
      <main>
        <Hero />
        <Looks />
        <Prints />
        <About />
        <Care />
        <Contact />
      </main>
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
